export const contactRoles = [
  'Entreprise Travaux',
  "Bureau d'Etudes",
  'Foncier',
  'Juridique',
] as const

export const contactSubrolesByRole: Record<(typeof contactRoles)[number], readonly string[]> = {
  'Entreprise Travaux': [
    'Gros-Oeuvre',
    'VRD',
    'Serrurerie',
    'Menuiserie Bois',
    'Peinture',
    'Plâtrerie',
    'Revêtements de Sol',
    'TCE',
    'Electricité',
    'CVC',
    'Plomberie',
    'Froid Commercial',
    'Fournisseur',
    'Résine',
    'Agenceur',
    'Vérifications Réglementaires',
    'Sécurité Incendie',
    'Anti-intrusion',
    'Vidéo-surveillance',
    'Nettoyage',
    'Contractant Général',
    'MOE',
    'Bureau de Contrôle',
    'CSPS',
  ],
  "Bureau d'Etudes": ['Géotechnicien', 'Géomètre'],
  Foncier: ['Huissier', 'Bailleur', 'Syndic', 'Agence', 'Propriétaire'],
  Juridique: ['Notaire', 'Avocat'],
}

export type ContactRole = string
export type ContactSubrole = string

export const contactRoleLabel: Record<string, string> = Object.fromEntries(
  contactRoles.map((role) => [role, role]),
)
